//
import { required } from "@/services/validations"
import ProductModel from "@/models/Warehouse/WhProductToSearch"
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
import ProductFilters from "@/views/Warehouse/WhProduct/list/filters"
import ProductHeaders from "@/views/Warehouse/WhProduct/list/headers"

//
import StockAdjustDetailHeaders from "./headers"

//
export default ({ g_branch_office_id, g_branch_office_id_selected, triggerWarehouse }) => [
    {
        name: "g_user_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            chips: true,
            itemText: "full_name",
            itemValue: "id",
            label: "Supervisor",
            loadingText: "Cargando usuarios...",
            model: UserModel,
            noDataText: "Sin usuarios.",
            noObject: true,
            readonly: true,
            rules: [ required ],
        },
    },
    {
        name: "wh_warehouse_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Bodega",
            loadingText: "Cargando bodegas...",
            model: WarehouseModel,
            noDataText: "Sin bodegas.",
            noObject: true,
            paramFilter: {
                g_branch_office_id,
            },
            rules: [ required ],
        },
        trigger: triggerWarehouse,
    },
    {
        name: "wh_selected_products",
        type: "data-table-model",
        flex: {
            "pt-0": true,
            "xs12": true,
            "d-grid": true,
        },
        props: {
            checkable: true,
            class: "v-card elevation-2 mb-4",
            headers: StockAdjustDetailHeaders,
            noActions: true,
            noDataText: "Sin productos.",
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                attachParams: {
                    stock_branch_office_id: g_branch_office_id,
                },
                filters: ProductFilters({ triggerWarehouse }).slice(0, -1).filter( ( e, i ) => i !== 3 ),
                headers: JSON.parse(JSON.stringify(ProductHeaders)).filter((e,i)=> i!==5).map(e => {
                    if(e.value === 'stock_total') {
                        e.value = 'stock_branch_office'
                    }
                    return e
                }),
                noPagination: false,
                mapper: row => {
                    //
                    row[ "g_branch_office_id" ] = g_branch_office_id_selected;
                    row[ "stock" ]              = row.stock_total
                    row[ "wh_product_id" ]      = row.id
                    //
                    return row
                },
                rowsPerPage: 25,
                submitText: "confirmar selección",
                service: ProductModel,
            },
            rowsPerPage: 50,
            rules: [ required ],
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: "Lista de productos incluidos en el inventario",
            toolbarColor: "primary",
            toolbarDark: true,
            toolbarDense: true,
        },
        slots: {
            'items': 'selected-items',
        },
    },
    {
        name: "description",
        type: "textarea",
        flex: {
            xs12: true,
        },
        props: {
            label: "Descripción",
            rules: [ required ],
        },
    },
]